import React from 'react'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import ReactPlayer from 'react-player/youtube'
import styles from './ProjectDetailsVideo.module.scss'
import ProjectDetailsCollapse from '../ProjectDetailsCollapse/ProjectDetailsCollapse'

interface ProjectDetailsVideoProps {
  video: string,
  showCollapse?: boolean
}

const ProjectDetailsVideo: React.FC<ProjectDetailsVideoProps> = (props) => {
  const { video, showCollapse = true } = props

  const { t } = useTranslation()

  const reactPlayerProps = {
    url: video,
    className: styles['react-player'],
    width: '100%',
    loop: true,
    controls: true
  }

  const reactPlayer = <div className={styles['player-wrapper']}>
    <ReactPlayer {...reactPlayerProps}/>
  </div>

  return (
    <>
      {showCollapse ? (
        <ProjectDetailsCollapse label={<CustomText label={t('Projects.Video')} strong/>}>
          {reactPlayer}
        </ProjectDetailsCollapse>
      ) : <>{reactPlayer}</>}
    </>
  )
}

export default ProjectDetailsVideo
